export default {
  fields: {
    id: 'id',
    image: 'image_thumbnail',
    title: 'name',
    url: 'custom_url',
  },
  getItemId: () => window.document.querySelector('input[name="product_id"]').value,
  getVariantId: () => undefined,
};
